import { FC } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { checkIsActive, KTSVG, WithChildren } from "../../../../helpers";
import { useLayout } from "../../../core";
import React from "react";
import { useStyleContext } from "../../../../helpers/StyleContext";

type Props = {
  to: string;
  title: string;
  icon?: string;
  fontIcon?: string;
  hasBullet?: boolean;
  textColor?: string;
  iconColor?: string;
};

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  textColor,
  iconColor,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config } = useLayout();
  const { app } = config;
  const { styleState } = useStyleContext();

  return (
    <div
      className="menu-item"
      style={{ color: styleState?.sidebar_text_color }}
    >
      <Link
        className={clsx("menu-link without-sub", { active: isActive })}
        to={to}
      >
        {hasBullet && (
          <span className="menu-bullet">
            <span
              className="bullet bullet-dot"
              style={{ backgroundColor: styleState?.sidebar_text_color }}
            ></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === "svg" && (
          <span
            className="menu-icon"
            style={{
              color: styleState?.sidebar_text_color,
            }}
          >
            {" "}
            <KTSVG
              path={icon}
              className="svg-icon-2"
              color={styleState?.sidebar_text_color}
            />
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === "font" && (
          <i
            className={clsx("bi fs-3", fontIcon)}
            style={{
              color: styleState?.sidebar_text_color,
            }}
          ></i>
        )}
        <span
          className="menu-title"
          style={{
            color: styleState?.sidebar_text_color,
          }}
        >
          {title}
        </span>
      </Link>
      {children}
    </div>
  );
};

export { SidebarMenuItem };
